import { lazy } from 'react';
import Switch from 'react-bootstrap-v5/lib/esm/Switch';
import { Redirect, Route, useRouteMatch } from 'react-router-dom';

export const CompaniesPage = () => {
    const { path } = useRouteMatch();
    const CompaniesList = lazy(() => import('./features/CompaniesList'));
    const CompanyDetails = lazy(() => import('./features/CompanyDetails'));
    const CompanyAddForm = lazy(() => import('./features/CompanyAddForm'));
    const CompanyEditForm = lazy(() => import('./features/CompanyEditForm'));
    
    return (
        <Switch>
            <Route exact path={`${path}`} component={CompaniesList}/>
            <Route exact path={`${path}/details/:id`} component={CompanyDetails}/>
            <Route exact path={`${path}/edit/:id`} component={CompanyEditForm}/>
            <Route exact path={`${path}/new`} component={CompanyAddForm}/>
            <Redirect to={path}/>
        </Switch>
    )
}